export default __webpack_public_path__ + "static/media/notHaveDoc.a0649b48.png";